import { css as c, LitElement as v, nothing as s, html as f } from "lit";
import { query as m, property as r, state as g, customElement as y } from "lit/decorators.js";
import { classMap as b } from "lit/directives/class-map.js";
import { live as w } from "lit/directives/live.js";
import { b as x, f as $ } from "./styles-scZ6dVz-.js";
import { b as n, a as p } from "./events-CkEPl0SM.js";
import { g as z } from "./a11y-DxQW21Jt.js";
var B = Object.defineProperty, E = Object.getOwnPropertyDescriptor, t = (a, o, d, l) => {
  for (var i = l > 1 ? void 0 : l ? E(o, d) : o, h = a.length - 1, u; h >= 0; h--)
    (u = a[h]) && (i = (l ? u(o, d, i) : u(i)) || i);
  return l && i && B(o, d, i), i;
};
let e = class extends v {
  constructor() {
    super(...arguments), this.textareaId = z("ark-textarea"), this.value = "", this.rows = 3, this.resize = "vertical", this.autoGrow = !1, this.disabled = !1, this.readonly = !1, this.required = !1, this.invalid = !1, this.autofocus = !1, this.hasFocus = !1;
  }
  /** Focus the textarea */
  focus(a) {
    this.textareaElement?.focus(a);
  }
  /** Blur the textarea */
  blur() {
    this.textareaElement?.blur();
  }
  /** Select all text */
  select() {
    this.textareaElement?.select();
  }
  handleInput(a) {
    const o = a.target;
    this.value = o.value, n(this, p.INPUT, { value: this.value });
  }
  handleChange(a) {
    const o = a.target;
    this.value = o.value, n(this, p.CHANGE, { value: this.value });
  }
  handleFocus() {
    this.hasFocus = !0, n(this, p.FOCUS);
  }
  handleBlur() {
    this.hasFocus = !1, n(this, p.BLUR);
  }
  render() {
    const a = {
      wrapper: !0,
      [`resize-${this.resize}`]: !0,
      "auto-grow": this.autoGrow,
      disabled: this.disabled,
      readonly: this.readonly,
      invalid: this.invalid,
      focused: this.hasFocus
    };
    return f`
      <div
        part="wrapper"
        class=${b(a)}
        data-replicated-value=${this.autoGrow ? this.value : s}
      >
        <textarea
          part="textarea"
          id=${this.textareaId}
          name=${this.name ?? s}
          .value=${w(this.value)}
          placeholder=${this.placeholder ?? s}
          rows=${this.rows}
          ?disabled=${this.disabled}
          ?readonly=${this.readonly}
          ?required=${this.required}
          ?autofocus=${this.autofocus}
          minlength=${this.minlength ?? s}
          maxlength=${this.maxlength ?? s}
          autocomplete=${this.autocomplete ?? s}
          aria-invalid=${this.invalid ? "true" : s}
          @input=${this.handleInput}
          @change=${this.handleChange}
          @focus=${this.handleFocus}
          @blur=${this.handleBlur}
        ></textarea>
      </div>
    `;
  }
};
e.styles = [
  x,
  $,
  c`
      :host {
        display: block;
      }

      .wrapper {
        display: flex;
        background-color: var(--r5-bg);
        border: 1px solid var(--r5-border);
        border-radius: var(--r5-radius-md);
        transition-property: border-color, box-shadow;
        transition-duration: var(--r5-duration-fast);
        transition-timing-function: var(--r5-ease-default);
        overflow: hidden;
      }

      .wrapper:focus-within {
        border-color: var(--r5-border-focus);
        box-shadow: 0 0 0 var(--r5-focus-ring-width) var(--r5-color-primary-100);
      }

      .wrapper.invalid {
        border-color: var(--r5-color-danger-500);
      }

      .wrapper.invalid:focus-within {
        box-shadow: 0 0 0 var(--r5-focus-ring-width) var(--r5-color-danger-100);
      }

      .wrapper.disabled {
        background-color: var(--r5-bg-muted);
        opacity: 0.5;
      }

      .wrapper.readonly {
        background-color: var(--r5-bg-subtle);
      }

      textarea {
        flex: 1;
        min-width: 0;
        min-height: 80px;
        border: none;
        background: transparent;
        color: var(--r5-text);
        font-family: inherit;
        font-size: var(--r5-text-sm);
        line-height: var(--r5-leading-normal);
        outline: none;
        padding: var(--r5-space-3);
      }

      textarea::placeholder {
        color: var(--r5-text-muted);
      }

      textarea:disabled {
        cursor: not-allowed;
      }

      /* Resize options */
      .resize-none textarea {
        resize: none;
      }

      .resize-vertical textarea {
        resize: vertical;
      }

      .resize-horizontal textarea {
        resize: horizontal;
      }

      .resize-both textarea {
        resize: both;
      }

      /* Auto-grow mode */
      .auto-grow {
        display: grid;
      }

      .auto-grow::after {
        content: attr(data-replicated-value) ' ';
        white-space: pre-wrap;
        visibility: hidden;
        padding: var(--r5-space-3);
        font-family: inherit;
        font-size: var(--r5-text-sm);
        line-height: var(--r5-leading-normal);
        border: 1px solid transparent;
      }

      .auto-grow textarea,
      .auto-grow::after {
        grid-area: 1 / 1 / 2 / 2;
      }
    `
];
t([
  m("textarea")
], e.prototype, "textareaElement", 2);
t([
  r({ type: String })
], e.prototype, "value", 2);
t([
  r({ type: String })
], e.prototype, "placeholder", 2);
t([
  r({ type: Number })
], e.prototype, "rows", 2);
t([
  r({ type: String })
], e.prototype, "resize", 2);
t([
  r({ type: Boolean, attribute: "auto-grow" })
], e.prototype, "autoGrow", 2);
t([
  r({ type: Boolean, reflect: !0 })
], e.prototype, "disabled", 2);
t([
  r({ type: Boolean, reflect: !0 })
], e.prototype, "readonly", 2);
t([
  r({ type: Boolean, reflect: !0 })
], e.prototype, "required", 2);
t([
  r({ type: Boolean, reflect: !0 })
], e.prototype, "invalid", 2);
t([
  r({ type: String })
], e.prototype, "name", 2);
t([
  r({ type: Number })
], e.prototype, "minlength", 2);
t([
  r({ type: Number })
], e.prototype, "maxlength", 2);
t([
  r({ type: String })
], e.prototype, "autocomplete", 2);
t([
  r({ type: Boolean })
], e.prototype, "autofocus", 2);
t([
  g()
], e.prototype, "hasFocus", 2);
e = t([
  y("ark-textarea")
], e);
export {
  e as A
};
//# sourceMappingURL=ark-textarea-D7JiVTMH.js.map
